import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectorRef, AfterViewInit, ViewChild } from '@angular/core';
import { CurrencyPipe } from '@angular/common';
import { Tooltip } from 'primeng/tooltip';

import { CalculationService, HelperService, DataService } from 'app/services';
import { currency } from 'app/constants/currency.constants';

@Component({
  selector: 'app-price-matrix-item',
  templateUrl: './price-matrix-item.component.html',
  styleUrls: ['./price-matrix-item.component.scss'],
})
export class PriceMatrixItemComponent implements OnInit, AfterViewInit {
  @ViewChild(Tooltip) tooltip!: Tooltip;
  @Input() pricing: any = {};
  @Input() index: number = 0;
  @Input() error: any = {};
  @Input() noOfItems: any = {};
  @Input() nextUpperLimit: number = 0;
  @Input() isPricingMatricesManagement: boolean = false;
  @Input() isPricingManagementEnable: boolean = false;
  @Input() isAttributeBasedPricingEnable: boolean = false;
  @Input() isNewItemCategoriesEnable: boolean = false;
  @Input() isReadOnlyPricing: boolean = false;

  @Output() itemFocus = new EventEmitter<any>();
  @Output() itemBlur = new EventEmitter<any>();
  @Output() deleteItem = new EventEmitter<any>();
  @Output() checkForChanges = new EventEmitter<any>();

  focus: any = {};
  salesPrice: number = 0;
  marginPercent: number = 0;
  usd: string = currency.USD;
  defaultUpperLimit: number = 0;
  isDeleteConfirmationVisible: boolean = false;

  constructor(private dataService: DataService, private calculationService: CalculationService, private helperService: HelperService, private currencyPipe: CurrencyPipe, private cdr: ChangeDetectorRef) {}

  ngOnInit() {
    this.calculateCostAndMargin();
    this.defaultUpperLimit = this.pricing.max;
  }

  ngAfterViewInit() {
    this.cdr.detectChanges();
  }

  showTooltip() {
    this.tooltip.activate();
  }

  handleChange(name: string, value: any) {
    if((name === 'margin')  && value >= 100) {return false}
    this.pricing[name] = value;
    this.checkForChanges.emit();
  }

  handleFocus(name: string) {
    this.focus[name] = true;
    this.itemFocus.emit();
    if (this.error) {
      this.error[name] = '';
    }
  }

  handleBlur(name: string) {
    this.focus[name] = false;

    if (name === 'max' && this.nextUpperLimit && this.pricing.max >= this.nextUpperLimit - 1) {
      this.helperService.showToaster(
        'error',
        `${this.currencyPipe.transform(this.pricing.max, this.usd)} is too high.
        Upper limit must be less than the next range's upper limit
        (${this.currencyPipe.transform(this.nextUpperLimit, this.usd)})`
      );
      this.pricing.max = this.defaultUpperLimit;
    } else if (name === 'margin'){
      this.calculateCostAndMarkup();
      this.defaultUpperLimit = this.pricing.max;
      this.itemBlur.emit({ index: this.index, name });
    }else {
      this.calculateCostAndMargin();
      this.defaultUpperLimit = this.pricing.max;
      this.itemBlur.emit({ index: this.index, name });
    }

    this.checkForChanges.emit();
  }

  deletePricingItem() {
    this.deleteItem.emit(this.index);
    this.isDeleteConfirmationVisible = false;
  }

  toggleConfirmDelete() {
    this.isDeleteConfirmationVisible = !this.isDeleteConfirmationVisible;
  }

  calculateCostAndMargin() {
    const { max = 0, markup = 0, margin = 0 } = this.pricing;

    const maxPrice = this.calculationService.roundOff(max);
    const markupPercent = this.calculationService.roundOff(markup);
    const salesPrice = this.calculationService.roundOff(maxPrice + (maxPrice * markupPercent) / 100);

    if (salesPrice) {
      this.marginPercent = this.calculationService.roundOff(((salesPrice - maxPrice) / salesPrice) * 100);
      this.pricing.margin = this.marginPercent
    } else {
      this.marginPercent = 0;
    }
    this.salesPrice = salesPrice;
  }

  calculateCostAndMarkup () {
    const { max = 0, markup = 0, margin = 0 } = this.pricing;

    const cost = this.calculationService.roundOff(max);
    const marg = margin /100
    const price = this.calculationService.roundOff(cost / ((1- marg)));
    const markupPercent = this.calculationService.roundOff((((price / cost)) -1 ) * 100 );
    this.pricing.markup =  markupPercent
  }
}
